import React, { ComponentType, ReactNode } from 'react';
import { Box, Container, Paper, SvgIconProps, Typography } from '@mui/material';

export interface CenteredPaperProps {
  icon?: ComponentType<SvgIconProps>;
  title?: string;
  children: ReactNode;
}

export const CenteredPaper = (props: CenteredPaperProps) => {
  const { icon, title, children } = props;

  const IconComponent = icon;

  return (
    <Container maxWidth={'sm'}>
      <Paper
        sx={{ margin: (theme) => theme.spacing(8, 0), padding: 4 }}
        elevation={3}
      >
        {IconComponent ? (
          <Box sx={{ textAlign: 'center', fontSize: 64 }}>
            <IconComponent fontSize={'inherit'} />
          </Box>
        ) : null}
        {title ? (
          <Typography sx={{ textAlign: 'center' }} variant={'h5'}>
            {title}
          </Typography>
        ) : null}
        {children}
      </Paper>
    </Container>
  );
};
